import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';

const loggerMiddleware = createLogger();

export const store = createStore(
  rootReducer,
  {
    game: {
      data: null,
    },
    users: {
      items: [],
    },
    schools: {
      items: [],
    },
  },
  applyMiddleware(thunkMiddleware, loggerMiddleware)
);
